import { useEffect } from "react";

export const useLockBodyScroll = (showLightbox: boolean) => {
    useEffect(() => {
        const body =
            document.querySelector(".c24-body") ||
            document.querySelector("#c24m-body");

        if (body instanceof HTMLElement && showLightbox) {
            body.style.overflow = "hidden";

            return () => {
                body.style.overflow = "";
            };
        }
    }, [showLightbox]);
};
